import Confirm from 'components/UI/Confirm'
import { createConfirmation } from 'react-confirm'

const defaultConfirmation = createConfirmation(Confirm);

export function confirm(confirmation, title, options = {}) {
  return defaultConfirmation({ confirmation, title, ...options });
}
export default confirm




// WEBPACK FOOTER //
// ./src/util/confirm.js